export const generalSettings = {
  // Configurações Gerais
  onlyLoggedUsers: false, // pede login pro cliente acessar a homepage
  inAppRegistration: true, // mostra o botão "Cadastrar" no login
  showWhatsappButton: true, // mostra o botão de Whatsapp no menu do cliente
  oneSignal: false, // habilita notificações
  markAsSeen: true, // permite marcar aulas como concluídas sem assistí-las
  enablePDFReaderAndWriter: false, // habilita editor de PDF para fazer anotações e marcações nas aulas do tipo arquivo
  enableSearch: true, // habilita busca de produtos e aulas no cabeçalho
  searchButtonIcon: 'fas fa-search', // ícone do font-awesome para o botão de busca
  myList: true, // permite que os clientes adicionem aulas à sua lista de favoritos
  certificates: true, // permite que os clientes consigam visualizar certificados dos cursos concluídos na plataforma
  defaultLanguage: 'pt', // linguagem padrão do app
  defaultPhoneCountry: 'Brazil', // país padrão do campo de telefone na tela de cadastro

  //Layout Geral
  buttonLayout: 'square', // 'rounded' | 'square' (layout dos botões - laterais 100% arredondadas, ou retas com as arestas levemente arredondadas)
  calendarButtonLayout: 'square', // 'rounded' | 'square' (layout dos botões de navegação e dia selecionado no calendário - mesmo esquema pra opção acima)
  timelineIconsLayout: 'square', // 'rounded' | 'square' (layout dos botões na timeline e detalhe do produto - info das aulas, expandir/recolher módulo, fechar modais)
  iconsType: 'font-awesome', // 'font-awesome' | 'images' (caso seja 'images', baixar todos os ícones do Zeplin para a pasta 'icons')
  footerHeight: 'regular', // 'regular' | 'mini' | 'hidden' | 'none'

  // Textos e outros (Geral)
  registrationButtonText: 'registration', // 'signUp' | 'account' | 'registration' : opção 1 para 'Cadastrar', 2 para 'Criar nova conta' ou 3 para 'Criar novo cadastro'

  // Layout Homepage/Timeline
  homeLayout: 'sections', // 'tabs' | 'sections' (só existe sections)
  homeProductsImageSize: 'small', // 'small' | 'medium' | 'large' (tamanho das thumbs dos produtos na timeline),
  homeProductsImageOrientation: 'portrait', // 'landscape' | 'portrait' (orientação das thumbs dos produtos na timeline)
  homeLessonsImageSize: 'medium', // 'small' | 'medium' | 'large' (tamanho das thumbs das próximas aulas na timeline),
  homeLessonsImageOrientation: 'landscape', // 'landscape' | 'portrait' (orientação das thumbs das próximas aulas na timeline)
  showProductsTitle: false, // mostrar nome do produto (texto) nas thumbs da timeline
  homeProductsTitleStyle: 'inside', // 'inside' | 'outside' (onde exibir o nome do produto - em cima da thumb ou logo abaixo - só funciona com o de cima habilitado)
  spotlightLayout: 'carousel', // 'medium-fullwidth' (1 CTA) | 'large-card' (2 CTAs) | 'carousel' (Slider) | 'cards-carousel' (Home 4.0)
  homeLayoutSection: 'navigation', // 'navigation' linha de produtos com setas laterais para navegação | 'list' lista de produtos com quebra de linhas

  //Layout Produtos (Interna - Lista de Módulos e Aulas)
  productDetailLayout: 'list', // 'thumbs' (thumbs das aulas) | 'list' (listagem de aulas),
  productDetailType: 'accordion', // 'accordion'
  productDetailThumbSize: 'large', // 'small' | 'medium' | 'large' (tamanho das thumbs das aulas caso o layout escolhido seja 'thumbs'),
  productDetailThumbOrientation: 'landscape', // 'landscape' | 'portrait' (orientação das thumbs das aulas caso o layout escolhido seja 'thumbs')
  showLessonsTitle: true, // exibir o nome das aulas (texto) caso o layout escolhido seja 'thumbs'
  lessonsTitleStyle: 'outside', // 'inside' | 'outside' (onde exibir o nome da aula - em cima da thumb ou logo abaixo - só funciona com o de cima habilitado)

  // Configurações da Homepage/Timeline
  enableTimeline: true,
  timelineLabel: 'Início', // label no menu principal
  timelineIcon: 'fas fa-home', // ícone do font-awesome no menu principal

  // Botões IA (conteúdos)
  aiButtonsLabel: {
    summary: 'labelSummary',
    quiz: 'labelQuiz',
    chat: 'labelChat',
  },

  // Configurações da Comunidade
  enableSociaMedia: true,
  allowUsersToCreatePosts: true, // permite que clientes criem postagens na comunidade
  onlyMembersCanPost: true, // somente clientes assinantes podem postar (só funciona com o de cima habilitado)
  socialMediaLabel: 'Comunidade', // label no menu principal
  socialMediaIcon: 'fas fa-chalkboard', // ícone do font-awesome no menu principal
  socialMediaLayout: 'pompous', // 'classic' | 'vintage' | 'modern' | 'dashing' | 'elegant' | 'refined' | 'pompous' (*)
  postsAndCommentsPerPage: 20, // número de postagens e comentários por página


  // Player de Vídeo
  showLessonsDescription: true, // mostra os detalhes da aula na tela de vídeo (desktop)
  enableCommentsOnLessons: true, // permite comentários nas aulas (só funciona com o de cima habilitado)
  pandaPlayerPrimaryColor: '#000', // cor dos botões do player de vídeo PANDA
  pandaPlayerControlsColor: '#000', // cores dos controles e menu do player de vídeo PANDA

  // Leitor/Notas de PDF
  pdfBackgroundTheme: 'dark' // 'dark' | 'light' : tema de fundo do leitor de PDF
}

/*
(*) socialMediaLayout
classic : ícones pequenos sem preenchimento ao redor (todo colorido ao curtir) e com texto "Ver Mais"
vintage : ícones pequenos sem preenchimento ao redor (borda colorida ao curtir) e com seta "=>"
modern  : ícones grandes com preenchimento ao redor e com seta "=>"
dashing : ícones pequenos com preenchimento ao redor e com texto "Ver Mais"
elegant : ícones pequenos sem preenchimento ao redor (todo colorido ao curtir) e com seta "=>"
refined : ícones pequenos sem preenchimento ao redor (borda colorida ao curtir) e com texto "Visualizar"
pompous : ícones pequenos sem preenchimento ao redor (todo colorido ao curtir) e com texto "Visualizar"

*/
